"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.customSubgraphQuery = exports.fetchAdminPodIds = exports.fetchUserPodIds = exports.fetchPodUsers = void 0;
var axios_1 = __importDefault(require("axios"));
var config_1 = require("../../config");
/**
 * Returns an array of addresses of all pod members.
 * @param id
 */
function fetchPodUsers(id) {
    return __awaiter(this, void 0, void 0, function () {
        var data, users;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios_1["default"].post(config_1.config.subgraphUrl, {
                        query: "query GetPodUsers($id: ID!) {\n          pod(id: $id) {\n            users {\n              user {\n                id\n              }\n            }\n          }\n        }",
                        variables: { id: id }
                    })];
                case 1:
                    data = (_a.sent()).data;
                    users = (data.data.pod || { users: [] }).users;
                    return [2 /*return*/, users.map(function (user) { return user.user.id; })];
            }
        });
    });
}
exports.fetchPodUsers = fetchPodUsers;
/**
 * Returns a list of Pod IDs from subgraph that user is a member of.
 * This function bypasses Pod construction and is mostly used for optimization purposes.
 * If you're unsure on what function to use, use `getUserPods` instead.
 * @param address
 */
function fetchUserPodIds(address) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var data, pods, podIds;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, axios_1["default"].post(config_1.config.subgraphUrl, {
                        query: "query GetUserPods($id: ID!) {\n        user(id: $id) {\n          pods {\n            id\n            pod {\n              id\n            }\n          }\n        }\n      }",
                        variables: { id: address.toLowerCase() }
                    })];
                case 1:
                    data = (_b.sent()).data;
                    pods = (((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.user) || { pods: [] }).pods;
                    podIds = pods.map(function (_a) {
                        var pod = _a.pod;
                        return parseInt(pod.id, 10);
                    });
                    return [2 /*return*/, podIds];
            }
        });
    });
}
exports.fetchUserPodIds = fetchUserPodIds;
/**
 * Returns an array of Pod IDs from sub graph that an address is the admin of
 * This function bypasses Pod construction and is mostly used for optimization purposes.
 * If you're unsure on what function to use, use `getAdminPods` instead.
 * @param address
 */
function fetchAdminPodIds(address) {
    return __awaiter(this, void 0, void 0, function () {
        var data, adminPods, podIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios_1["default"].post(config_1.config.subgraphUrl, {
                        query: "query GetUserPods($id: ID!) {\n        user(id: $id) {\n          adminPods\n        }\n      }",
                        variables: { id: address.toLowerCase() }
                    })];
                case 1:
                    data = (_a.sent()).data;
                    adminPods = (data.data.user || { adminPods: [] }).adminPods;
                    podIds = adminPods.map(function (pod) { return parseInt(pod, 10); });
                    return [2 /*return*/, podIds];
            }
        });
    });
}
exports.fetchAdminPodIds = fetchAdminPodIds;
/**
 * Makes a custom call on the subgraph by passing a query in directly.
 * Note that this data will likely require manual transformation to be usable.
 *
 * Example: Making a call to retrieve pod IDs 1 through 3:
 *
 * ```js
 * await customSubgraphQuery(`{
 *    pods(where: {
 *      id_in: [1, 2, 3]
 *    }) {
 *      id
 *      users {
 *        id
 *      }
 *      admin
 *    }
 *  }`
 *
 * Which will return:
 *
 * ```
 * {
 *  pods: [
 *    {
 *      id: '1',
 *      users: [Array],
 *      admin: '0x0000000000000000000000000000000000000000'
 *    },
 *    {
 *      id: '2',
 *      users: [Array],
 *      admin: '0x0000000000000000000000000000000000000000'
 *    },
 *    {
 *      id: '3',
 *      users: [Array],
 *      admin: '0x4b4c43f66ec007d1dbe28f03dac975aab5fbb888'
 *    }
 *  ]
 * }
 *  ```
 *
 * Note these are not Pod objects as defined by the SDK.
 *
 * @param query - GraphQL query
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function customSubgraphQuery(query) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios_1["default"].post(config_1.config.subgraphUrl, {
                        query: query
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.data];
            }
        });
    });
}
exports.customSubgraphQuery = customSubgraphQuery;
